const markUnderscoreEmphasisAsUnderline = (node, source) => {
  if (node.type === 'emphasis' && node.position) {
    const marker = source.slice(node.position.start.offset, node.position.start.offset + 1);
    if (marker === '_') {
      node.data = { ...node.data, hName: 'u' };
    }
  }

  if (Array.isArray(node.children)) {
    node.children.forEach((child) => markUnderscoreEmphasisAsUnderline(child, source));
  }
};

export const remarkUnderline = () => (tree, file) => {
  markUnderscoreEmphasisAsUnderline(tree, String(file.value ?? ''));
};
